export enum CustomerGroupTabs {
    DETAILS = 'details',
    TWO_STEP_AUTH = 'twoStepAuthentication',
    SSO = 'singleSignOn',
    SETTINGS = 'settings',
    DEVELOPERS = 'developers',
}
